<template>
  <div class="mod" :class="{'isEn': isEn}">
    <div class="top-banner">
      <span class="about-label banner-txt-con" :style="{left:`${left}px`}">
        {{$t('contact-banner-txt1')}} 
      </span>
    </div>
    <div class="linkBox">
      <div class="link-tab">
        <div @click="tabEvent(0, 'teameone')" :class="btnActiveIndex === 0 ? 'link-btn link-btn-active' : 'link-btn'">{{$t('contact-btn-txt1')}} </div>
        <div @click="tabEvent(1, 'teamtwo',-200)" :class="btnActiveIndex === 1 ? 'link-btn link-btn-active' : 'link-btn'">{{$t('contact-btn-txt2')}} </div>
      </div>
    </div>

<div >
  <div class="teamsubmain" id="teameone">
          <span class="location-1">{{$t('contact-btn-txt1')}} </span>
        </div>
  </div>
  <!-- <div class="row-1 zoomCenterTop" >
     
      <div class="team-col2">
        <div class="team-col2-item">
          <img class="team-col2-icon" src="@/assets/img/teamwork/images/img_13.png" />
          <div class="team-col2-title">{{$t('contact-part1-c1-txt1')}} </div>
          <div class="team-col2-desc">{{$t('contact-part1-c1-txt2')}} </div>
        </div>
        <div class="team-col2-item">
          <img class="team-col2-icon" src="@/assets/img/teamwork/images/img_14.png" />
          <div class="team-col2-title">{{$t('contact-part1-c2-txt1')}} </div>
          <div class="team-col2-desc">{{$t('contact-part1-c2-txt2')}} </div>
        </div>
       
      </div>
    </div>
    <div class="row-1 zoomCenterTop">
      <div class="team-col2">
        <div class="team-col2-item">
          <img class="team-col2-icon" src="@/assets/img/teamwork/images/img_17.png" />
          <div class="team-col2-title">{{$t('contact-part1-c3-txt1')}} </div>
          <div class="team-col2-desc">{{$t('contact-part1-c3-txt2')}} </div>
        </div>
        <div class="team-col2-item">
          <img class="team-col2-icon" src="@/assets/img/teamwork/images/img_19.png" />
          <div class="team-col2-title">{{$t('contact-part1-c4-txt1')}} </div>
          <div class="team-col2-desc">{{$t('contact-part1-c4-txt2')}} </div>
        </div>
       
      </div>
    </div> -->
    <div class="row-2 zoomCenterTop">
      <div class="block-7">
        <img class="banner-team" src="@/assets/img/teamwork/images/img_20.webp" />
      </div>
      <div class="block-8" :class="{'en':isEn}">
        <h3 class="address-1">{{$t( "contact-part1-p-txt1")}}</h3>
        <span class="container-teamwork4" >{{$t( "contact-part1-p-txt2")}}</span>
        
        <div class="container-3">
          <!-- <span class="word-1"><img class="icon-yyy" src="@/assets/img/prefecture/images/img_11.svg" />{{$t( "contact-part1-p-i1")}}</span>
          <img class="icon-4" src="@/assets/img/prefecture/images/img_11.svg" />
          <span class="meta">{{$t( "contact-part1-p-i3")}}</span>
          <img class="icon-5" src="@/assets/img/prefecture/images/img_11.svg" />
          <span class="organization">{{$t( "contact-part1-p-i5")}}</span> -->

          <div class="groupItem01" :class="{'en':isEn}" >
                  <span >  
                      {{$t('contact-part1-p-i1')}}</span>
                  
                    <span >
                      {{$t('contact-part1-p-i3')}}
                    </span>
                 
                  <span >{{$t('contact-part1-p-i5')}}</span>
                
                </div>
        </div>
      
       
              



        <div class="container-4">
          <!-- <span class="subtitle">  <img class="icon-yyy" src="@/assets/img/prefecture/images/img_11.svg" />{{$t( "contact-part1-p-i2")}}</span>
          <img class="icon-7" src="@/assets/img/prefecture/images/img_11.svg" />
          <span class="tag-2">{{$t( "contact-part1-p-i4")}}</span> -->
          <div class="groupItem01" :class="{'en':isEn}" >
                  <span >  
                      {{$t('contact-part1-p-i4')}}</span>
                  
                    <span >
                      {{$t('contact-part1-p-i2')}}
                    </span>
                 
                
                </div>
        </div>
        <span class="address-1">{{$t( "contact-part1-p-txt3")}}</span>
        <div class="container-5">
          <div class="wrapper-2">
            <div class="group-2">
              <div class="view">
                <img src="@/assets/img/teamwork/images/people.png" />
              </div>
              <span class="label-2">{{ userdata.contact }} </span>
            </div>
            <div class="group-3">
              <div class="view-1">
                <img src="@/assets/img/teamwork/images/phone.png" />
              </div>
              <span class="tel">{{ userdata.mobile }} </span>
            </div>
          </div>
          <div class="wrapper-3">
            <div class="group-4">
              <img src="@/assets/img/teamwork/images/mes.png" />
            </div>
            <span class="email">zhoujiahui@kanglinbio.com</span>
          </div>
        </div>
      </div>
    </div>
    <div class="bj-f8f8f8">
      <div id="teamtwo" class="has-zoom">
      <div class="row-3">
        <div class="caption-wrapper"><span class="caption">{{$t( "contact-banner-txt1")}}</span></div>
        <div class="block-9">
          <div class="container-6">
            <span class="detail">{{$t( "contact-part1-p-txt5")}}</span>
            <div class="horizontal-line" />
            <div class="wrapper-4">
              <div class="group-5">
                <img class="icon-9" src="@/assets/img/teamwork/images/icon_phone.svg" />
                <span class="telephone">{{ userdata.companyMobile }}</span>
              </div>
              <div class="group-6">
                <div class="view-2">
                  <img class="icon-10" src="@/assets/img/teamwork/images/icon_mail.svg" />
                  <img class="icon-11" src="@/assets/img/teamwork/images/icon_address.svg" />
                </div>
                <span class="company">
                  <span>wulingyan@kanglinbio.com</span>
                  <span class="map">{{ userdata.companyAddress }}</span>
                </span>
              </div>
            </div>
            <div class="wrapper-5">
              <span class="word-2" @click="mapEvent">{{$t( "contact-part1-p-txt7")}}</span>
              <img src="@/assets/img/map.png" />

            </div>
          </div>
          <div v-if="true" class="container-7">
            <!-- <div class="wrapper-item-0">
              <span class="mail-prev">职业发展</span>
              <span class="mail">wulingyan@kanglinbio.com</span>
            </div>
            <div class="wrapper-item-1">
              <span class="email-prev">媒体事务</span>
              <span class="email-1">zhoujiahui@kanglinbio.com</span>
            </div>
            <div class="wrapper-item-2">
              <span class="mail-prev-1">业务发展</span>
              <span class="mail-1">zhoujiahui@kanglinbio.com</span>
            </div> -->
          </div>
        </div>
      </div>
    </div>
    </div>
    
  </div>
</template>
<script>

import { menuFixed } from '@/utils/index'


export default {
  computed: {
    userdata () {
      return this.$store.state.user.userinfo
    }
  },
  data () {
    return {
      isEn:localStorage.getItem("lang") === 'EN',
      left:'',
      btnActiveIndex: 0,
    }
  },
  methods: {

    bannerloadEvent(){
      this.left = $('.header-nav').offset() && $('.header-nav').offset().left + 74  - $('.top-banner').offset().left
    },
    tabEvent (index, id,num=0) {
      this.btnActiveIndex = index
      let isfixed =  $('.linkBox').css('position') === 'fixed'
      let offset = index == 0 && isfixed ? 65 : 0
      if(!isfixed && index!==0){
        offset -= 65
      }
      const top = $('#'+ id).offset().top - 134 + offset - num
      $("html,body").animate({scrollTop: top},500);
    },
    mapEvent(){
      window.open('https://map.baidu.com/poi/康霖生物科技(杭州)有限公司/@13396334.070863035,3525250.081777669,19z?uid=6d6b72d4f7bed5f12bb97c5d&ugc_type=3&ugc_ver=1&device_ratio=2&compat=1&pcevaname=pc4.1&querytype=detailConInfo&da_src=shareurl')
    },
    onScrollSwitchTabAbout(){
      var that = this
      window.addEventListener('scroll', function () {
        var tarElArr = [$("#teameone"), $("#teamtwo")]
        var tarElScrollArr = [tarElArr[0].offset().top - 110, 
        tarElArr[1].offset().top - 110,
        //  tarElArr[2].offset().top - 110,
        //  tarElArr[3].offset().top -150
        ] 
        var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        console.log(scrollTop)
        if (scrollTop >= 0 && scrollTop <= tarElScrollArr[0]) {
          that.btnActiveIndex = 0

        }
        else if (tarElScrollArr[0] < scrollTop && scrollTop <= tarElScrollArr[1]) {
          that.btnActiveIndex = 0
        } else {
          that.btnActiveIndex = 1
        }
        

        console.log('this.btnActiveIndex'+ that.btnActiveIndex)
    })
  }
  },
  mounted () {
    menuFixed()
    let index= this.$route.query.index;
    setTimeout(()=>{
        this.bannerloadEvent()
       index && $('.link-btn')[index].click()
       this.onScrollSwitchTabAbout()
    },100)
  }

}
</script>

<style lang="less" scoped>

.top-banner{
      width: 100%;
      background: url(../../assets/img/webp/Teamwork.webp) no-repeat top;
      background-size: cover;
  }
.view-2{
  .icon-10{
    top:-4px;
  }
  .icon-11{
    
  }
}

.block-8 {
  // display: flex;
  // flex-direction: column;
  // justify-content: flex-start;
  // align-self: center;
  position: relative;
  height: 380px;
  width: 512px;
  margin-left: 128px;

  &.en{
    height: 448px;
    .article-4{
      height: 120px;
      overflow: hidden;
    }
   
  }
}


.groupItem01 {
  width: 586px;
  height: 30px;
  display: flex;
  align-self: center;
  position: relative;
  margin-bottom: 20px;
  flex-wrap: wrap;
  &:first-child{
   
  }
  span{
    display: block; 
    background: url('../../assets/img/prefecture/images/img_11.svg') no-repeat;
    background-size: 24px;
    background-position: 0 3px;
    width: 33%;
    line-height: 30px;
    padding-left: 32px;
    font-size: 14px;
    color: #000;
    margin-bottom: 20px;
    
  }
  &.en{
    width: 705px;
    span{
      &:first-child{
        width: 165px;
      }
      &:last-child{
        width: 232px;
      }
      &:nth-child(2){
        width: 232px;
      }
    }
  }
}



</style>

<style src="./index.css" scoped />
;



// WEBPACK FOOTER //
// src/view/Teamwork/index.vue